module.exports = __webpack_public_path__ + "img/tx_004.a34befd8.png";